import { MedicineForListModel } from '../medicineForListModel';
import { DiseaseForGridModel } from '../diseaseForGridModel';

export class InteractionsModel {
  public userId: number;
  public medicines: Array<MedicineForListModel>;
  public userMedicines: Array<MedicineForListModel>;
  public userDiseases: Array<DiseaseForGridModel>;
  public drivingAndMachine: boolean;
  public pregnancyAndBreastfeeding: boolean;
}